import React from 'react'
import styled from 'styled-components'

import Table from 'components/Table'

import DeviceRow from 'pages/shared/CustomerList/CustomerDeviceList/DeviceRow'

import { Customer } from 'types/Customer'
import { Device } from 'types/Device'

type Props = {
  customer: Customer
  updateRefreshTimestampCallback: () => void
}

const CustomerDeviceList = ({ customer, updateRefreshTimestampCallback }: Props) => {
  return (
    <S.DevicesCell>
      {customer.devices?.map((device) => (
        <DeviceRow
          key={device.deviceId}
          customer={customer}
          device={device as Device}
          updateRefreshTimestampCallback={updateRefreshTimestampCallback}
        />
      ))}
    </S.DevicesCell>
  )
}

export default CustomerDeviceList

const S = {
  DevicesCell: styled(Table.Cell)`
    overflow: hidden;
    flex: 5;
    flex-direction: column;
  `
}
